import { Component, OnInit } from '@angular/core';
import { MenuController, ModalController, ToastController } from '@ionic/angular';
import { HttpService } from 'src/app/services/http.service';
import { AuthService } from 'src/app/services/auth.service';
import { NamePage } from '../register/name/name.page';
import packageInfo from '../../../../package.json';

@Component({
  selector: 'app-login',
  templateUrl: './login.page.html',
  styleUrls: ['./login.page.scss'],
})
export class LoginPage implements OnInit {
  public appVersion: string = packageInfo.version;
  public user: any = {
    password: '',
    email: '',
  };
  public messageErrorEmail: any = {
    message: '',
    status: false,
  };
  public messageErrorPass: any = {
    message: '',
    status: false,
  };
  public loginStatus: boolean;
  public load: boolean;
  public loadGoogle = false;
  public showPassword = false;

  constructor(
    private menu: MenuController,
    private httpService: HttpService,
    private toastCtrl: ToastController,
    private modalCtrl: ModalController,
    private authService: AuthService
  ) {
    this.menu.enable(false, 'principalMenu');
  }

  ngOnInit() {}

  ionViewWillEnter() {
    // Ensure the side menu is disabled for this page
    this.menu.enable(false, 'principalMenu');
  }

  ionViewWillLeave() {
    // Re-enable the side menu when leaving this page
    this.menu.enable(true, 'principalMenu');
  }

  async requestPasswordRecover() {
    this.load = true;
    try {
      const response = await this.httpService.post('login-methods', this.user.email).toPromise();
      if ((response as any).message === 'Usuário encontrado') {
        await this.httpService.post('recoverPass', { email: this.user.email }).toPromise();
        await this.presentToast('Email enviado para: ' + this.user.email, 'primary');
      }
    } catch (e: any) {
      console.error(e);
      const errorCode = e?.error?.code || e?.code;
      const httpStatus = e?.status;
      const errorMessage = e?.error?.message || e?.message || 'Erro desconhecido';
      if (httpStatus === 404 || errorCode === 'auth/user-not-found') {
        await this.presentToast('Não há usuário com esse email: ' + this.user.email, 'danger');
        return;
      }
      if (errorCode === 'auth/invalid-email') {
        await this.presentToast('O email digitado é invalido', 'danger');
        return;
      }
      if (errorCode === 'auth/internal-error') {
        await this.presentToast('Um erro ocorreu: ' + errorMessage, 'danger');
        return;
      }
      if (errorCode === 'auth/too-many-requests') {
        await this.presentToast('Houve muitas tentativas de acesso, tente novamente mais tarde', 'danger');
        return;
      }
      await this.presentToast('Um erro ocorreu: ' + errorMessage, 'danger');
      return;
    } finally {
      this.load = false;
    }
  }

  changeEmail() {
    this.messageErrorEmail.status = false;
    this.messageErrorPass.status = false;
  }

  changePass() {
    this.messageErrorPass.status = false;
  }

  async login(user) {
    document.getElementById('login').setAttribute('disabled', '');
    this.load = true;
    const re = /\S+@\S+\.\S+/;

    if (!re.test(user.email)) {
      this.messageErrorEmail.message = 'O email digitado é invalido!';
      this.messageErrorEmail.status = true;
      document.getElementById('login').removeAttribute('disabled');
    }

    if (!this.messageErrorEmail.status && !this.messageErrorPass.status) {
      try {
        const data: any = await this.httpService.post('login', this.user).toPromise();
        localStorage.setItem('token', JSON.stringify(data.token));
        await this.updateUserLocalStorage(data);
        this.updateLoginLocalStorage();
        await this.modalCtrl.dismiss();
        location.replace('home');
      } catch (err: any) {
        const errorMessages = {
          'auth/wrong-password': 'Senha incorreta',
          'auth/user-not-found': 'Email não cadastrado',
          'auth/too-many-requests': 'Houve muitas tentativas de acesso, tente novamente mais tarde',
        };
        const errorCode = err?.error?.code || err?.code;
        const errorMessage = errorMessages[errorCode];
        if (errorMessage) {
          this.messageErrorPass.message = errorMessage;
          this.messageErrorPass.status = true;
          this.presentToast(errorMessage);
        } else {
          this.presentToast('Ocorreu um erro');
          console.error(err);
        }
        document.getElementById('login').removeAttribute('disabled');
      }
    }
    this.load = false;
    document.getElementById('login').removeAttribute('disabled');
  }

  async loginWithGoogle() {
    this.loadGoogle = true;
    try {
      const idToken = await this.authService.signInWithGoogle();
      const data: any = await this.httpService.post('auth/google', { idToken }).toPromise();
      localStorage.setItem('token', JSON.stringify(data.token));
      this.authService.attachPendingGoogleRefreshToken();
      await this.updateUserLocalStorage(data);
      this.updateLoginLocalStorage();
      await this.modalCtrl.dismiss();
      location.replace('home');
    } catch (err: any) {
      const msg = err?.error?.message || err?.message || 'Não foi possível entrar com Google.';
      this.presentToast(msg, 'danger');
    } finally {
      this.loadGoogle = false;
    }
  }

  async singUpPage() {
    // Store reference to modalCtrl before dismissing
    const modalCtrl = this.modalCtrl;

    // Close login modal first
    await this.modalCtrl.dismiss();

    // Open register modal
    const registerModal = await modalCtrl.create({
      component: NamePage,
      cssClass: 'register-modal-fullscreen',
      backdropDismiss: true,
    });
    await registerModal.present();

    // Wait for register modal to close
    await registerModal.onDidDismiss();

    // Check if user completed registration (logged in)
    const loginStatus = JSON.parse(localStorage.getItem('loginStatusDB') || 'false');
    if (!loginStatus) {
      // User closed register without completing - re-open login modal
      const loginModal = await modalCtrl.create({
        component: LoginPage,
        cssClass: 'login-modal-fullscreen',
        backdropDismiss: true,
      });
      await loginModal.present();
    }
  }

  back() {
    this.modalCtrl.dismiss();
  }

  async updateUserLocalStorage(user) {
    localStorage.setItem('userDB', JSON.stringify(user));
    await this.mergeGuestAddressIntoUser();
  }

  /** If user added an address while guest (homeFilterAddress), add it to their account and save to backend */
  private async mergeGuestAddressIntoUser() {
    try {
      const guestAddrJson = localStorage.getItem('homeFilterAddress');
      if (!guestAddrJson) return;
      const guestAddr = JSON.parse(guestAddrJson);
      if (!guestAddr || (!guestAddr.city && !guestAddr.state && !guestAddr.line_1)) return;

      const userDBJson = localStorage.getItem('userDB');
      if (!userDBJson) return;
      const userDB = JSON.parse(userDBJson);
      const user = userDB?.user || userDB;
      if (!user || !user.id) return;

      const address = {
        line_1: guestAddr.line_1 || `${guestAddr.district || ''}, ${guestAddr.city || ''}`.replace(/^,\s*/, '') || guestAddr.city || '',
        city: guestAddr.city || '',
        state: guestAddr.state || '',
        country: guestAddr.country || 'BR',
        zip_code: guestAddr.zip_code || '',
        compliment: guestAddr.compliment || '',
      };
      if (!address.line_1 && !address.city) return;

      user.address = address;
      if (!user.addresses) user.addresses = [];
      const alreadyHas = user.addresses.some(
        (a: any) => a.city === address.city && a.state === address.state && (a.line_1 === address.line_1 || !address.line_1)
      );
      if (!alreadyHas) {
        user.addresses.unshift(address);
      }
      if (userDB.user) userDB.user = user;
      else Object.assign(userDB, { user });
      localStorage.setItem('userDB', JSON.stringify(userDB));
      localStorage.setItem(`homeFilterAddress_${user.id}`, guestAddrJson);

      // Persist address on backend
      const opts = this.httpService.getOpts();
      if (opts) {
        await this.httpService.put('user/' + user.id, { address: user.address, addresses: user.addresses }, opts).toPromise();
      }
    } catch (_) {}
  }

  updateLoginLocalStorage() {
    localStorage.setItem('loginStatusDB', JSON.stringify(true));
  }

  async presentToast(message: string, color = 'danger') {
    const toast = await this.toastCtrl.create({
      message,
      duration: 2000,
      color,
      cssClass: 'ft-sz-16 ion-text-center',
    });
    toast.present();
  }
}
